import { render, staticRenderFns } from "./DelMenu.vue?vue&type=template&id=61fb8356&scoped=true"
import script from "./DelMenu.vue?vue&type=script&lang=js"
export * from "./DelMenu.vue?vue&type=script&lang=js"
import style0 from "./DelMenu.vue?vue&type=style&index=0&id=61fb8356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb8356",
  null
  
)

export default component.exports